import getParentNode from "./auth-service-tools1177.js";
import isScrollParent from "./auth-service-tools1175.js";
import getNodeName from "./auth-service-tools1153.js";
import { isHTMLElement } from "./auth-service-tools1025.js";

function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

export { getScrollParent as default };